export default __webpack_public_path__ + "static/media/robopunks.4114a617.PNG";